/**
 * backend-api
 * LoopBack Application
 *
 * OpenAPI spec version: 4.31.3
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import { Brand } from '..';
import ApiClient from '../ApiClient';
import Dealer from './Dealer';
import ObjectID from './ObjectID';

/**
* The Category model module.
* @module model/Category
* @version 4.31.3
*/
export default class Category {
    /**
    * Constructs a new <code>Category</code>.
    * @alias module:model/Category
    * @class
    * @param name {String} 
    * @param label {String} 
    * @param scope {String} 
    */

    constructor(name, label, scope) {
        
        
        this['name'] = name;
        this['label'] = label;
        this['scope'] = scope;
        
    }

    /**
    * Constructs a <code>Category</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/Category} obj Optional instance to populate.
    * @return {module:model/Category} The populated <code>Category</code> instance.
    */
    static constructFromObject(data, obj) {        
        if (data) {
            obj = obj || new Category();
                        
            
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('scope')) {
                obj['scope'] = ApiClient.convertToType(data['scope'], 'String');
            }
            if (data.hasOwnProperty('brand')) {
                obj['brand'] = ApiClient.convertToType(data['brand'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ObjectID.constructFromObject(data['id']);
            }
            if (data.hasOwnProperty('parentId')) {
                obj['parentId'] = ObjectID.constructFromObject(data['parentId']);
            }

            if (data.hasOwnProperty('visibility')) {
                obj['visibility'] = ObjectID.constructFromObject(data['visibility']);
            }
            if (data.hasOwnProperty('brandOwnerId')) {
                obj['brandOwnerId'] = ObjectID.constructFromObject(data['brandOwnerId']);
            }
            if (data.hasOwnProperty('children')) {
                obj['children'] = ApiClient.convertToType(data['children'], [Category]);
            }
            if (data.hasOwnProperty('parent')) {
                obj['parent'] = ApiClient.convertToType(data['parent'], Category);
            }
            if (data.hasOwnProperty('owner')) {
                obj['owner'] = ApiClient.convertToType(data['owner'], Brand);
            }
            if (data.hasOwnProperty('dealers')) {
                obj['dealers'] = ApiClient.convertToType(data['dealers'], [Dealer]);
            }
        }
        return obj;
    }

    /**
    * @member {String} name
    */
    name = undefined;
    /**
    * @member {String} label
    */
    label = undefined;
    /**
    * @member {String} scope
    * @default 'tag'
    */
    scope = 'tag';
    /**
    * @member {String} brand
    */
    brand = undefined;
    /**
    * @member {module:model/ObjectID} id
    */
    id = undefined;
    /**
    * @member {module:model/ObjectID} parentId
    */
    parentId = undefined;
    /**
    * @member {module:model/ObjectID} companyAccountOwnerId
    */
    companyAccountOwnerId = undefined;




}
